import UAParser from "ua-parser-js";

const UNKNOWN = "Unknown";

// Types for better type safety
type DevicePlatform = "mobile" | "tablet" | "web";

export const getDevicePlatform = (
  checkForTablet: boolean = true,
): DevicePlatform => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (
    /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
  )
    return "mobile";
  if (/ipad|tablet/i.test(userAgent) && checkForTablet) return "tablet";
  return "web";
};

export const isIOSDevice = (userAgent?: string): boolean => {
  if (!userAgent) return false;
  const parser = new UAParser(userAgent);
  const os = parser.getOS().name;
  return os === "iOS";
};
